module.exports = __webpack_public_path__ + "img/compare.10364c35.svg";